import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../../Include/Footer";
import { getParty } from "../../../../../Store/Store/Party/Party";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import toast from "react-hot-toast";
import { V_URL } from "../../../../../BaseUrl";
import axios from "axios";
import PurchaseOrderFields from "./components/PurchaseOrderFields";
import PurPoItems from "./components/PurPoItems";
import { getItem } from "../../../../../Store/Store/Item/Item";
import { getViewPoItems } from "../../../../../Store/prosafe/proTransaction/PurOrder/getViewPoItems";
import { getStorePayment } from "../../../../../Store/Store/StoreMaster/PaymentMethod/getPaymentList";
import ReactQuill from "react-quill";
import { quillFormats, quillModules } from "../../../../../helper/quotation";
import { getQuotation } from "../../../../../Store/Store/StoreMaster/Quotation/getQuotationList";

const DEFAULT_PO_TERMS = `1. Materials should be Supplied for the Specifications and Quality standards.<br />2. Delivery Within The Distribution Time is Mandatory.<br />3. Any Defect of Materials Will be returned.<br />4. Supplier Must Submit a Proper Tax Invoice With GST Details.<br />5. Po Number Must be Mentioned on All Invoices and Delivery Challan. <br />
<br />Thanks for doing business with us.<br />
`;

const ManagePurOrder = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    master_id: "",
    party_id: "",
    project_id: "",
    manual_pro_no: "",
    payment_method_id: "",
    quotation_id: "",
  });
  const [itemsArr, setItemsArr] = useState([]);
  const [termsCondition, setTermsCondition] = useState(DEFAULT_PO_TERMS || "");

  useEffect(() => {
    dispatch(getGenMaster({ tag_id: 10 }));
    dispatch(getProject());
    dispatch(getParty({ is_main: true }));
    dispatch(getItem({ is_main: true }));
    dispatch(getStorePayment({ status: "true" }));
    dispatch(getQuotation());
  }, []);

  const itemData = useSelector((state) => state?.getViewPoItems?.user?.data);

  useEffect(() => {
    if (data?._id) {
      dispatch(getViewPoItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: moment(data?.trans_date).format("YYYY-MM-DD"),
        master_id: data?.create_by?._id,
        project_id: data?.project_details?._id,
        manual_pro_no: data?.manual_pro_no,
        party_id: data?.party_details?._id,
        payment_method_id: data?.payment_method_id,
        quotation_id: data?.quotation_details?._id,
      });
    } else {
      setForm({
        trans_date: moment(Date.now()).format("YYYY-MM-DD"),
        master_id: "",
        party_id: "",
        project_id: "",
        manual_pro_no: "",
        payment_method_id: "",
        quotation_id: "",
      });
      setItemsArr([]);
      setError({});
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details);
      } else {
        setItemsArr([]);
      }
    } else {
      setItemsArr([]);
    }
  }, [itemData, data]);
  useEffect(() => {
    if (data?._id) {
      setTermsCondition(data?.termsCondition);
    }
  }, [data]);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Order",
      link: "/main-store/user/purchase-order-management",
    },
    { label: data?._id ? "Edit" : "Add" + " Purchase Order", active: true },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    if (!validateItems()) return;

    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-add-one-po`;

    const payload = {
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      tag_number: 10,
      trans_date: form.trans_date,
      master_id: form.master_id,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,
      party_id: form.party_id,
      quotation_id: form.quotation_id ? form.quotation_id : null,
      payment_method_id: form.payment_method_id,
      items_details: JSON.stringify(itemsArr),
      termsCondition: termsCondition,
    };

    axios({
      method: "post",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-order-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleUpdate = () => {
    if (!validateForm()) {
      return;
    }

    if (!validateItems()) return;

    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-update-po`;

    const payload = {
      trans_date: form.trans_date,
      id: data?._id,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,
      master_id: form.master_id,
      party_id: form.party_id,
      quotation_id: form.quotation_id ? form.quotation_id : null,
      payment_method_id: form.payment_method_id,
      termsCondition: termsCondition,
    };

    axios({
      method: "put",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-order-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const validateItems = () => {
    if (!itemsArr || itemsArr.length === 0) {
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const isQuillBlank = (value) => {
    const text = value.replace(/<[^>]+>/g, "").trim();
    return text.length === 0;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }
    if (!form.master_id) {
      newErrors.master_id = "Requested by is required";
      isValid = false;
    }
    if (!form.project_id) {
      newErrors.project_id_err = "Project is required";
      isValid = false;
    }
    if (!form.party_id) {
      newErrors.party_id_err = "Party is required";
      isValid = false;
    }
    if (!form.payment_method_id) {
      newErrors.payment_err = "Payment Method is required";
      isValid = false;
    }

    if (isQuillBlank(termsCondition)) {
      newErrors.terms_err = "Terms and Conditions can't be empty";
      isValid = false;
    }

    setError(newErrors);
    return isValid;
  };

  const handleReset = () => {
    setForm({
      trans_date: "",
      master_id: "",
      party_id: "",
      project_id: "",
    });
    setError({});
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>
                          {data?._id ? "Edit" : "Add"} Purchase Order Details
                        </h4>
                      </div>
                    </div>
                    <PurchaseOrderFields
                      form={form}
                      handleChange={handleChange}
                      error={error}
                      data={data}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          <PurPoItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            data={data}
            form={form}
          />

          {/* Terms and condition section  */}
          <div className="row mb-3">
            <div className="col-12 ">
              <div
                className="card shadow-sm h-100"
                style={{ border: "1px solid #e0e0e0" }}
              >
                <div
                  className="card-header"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid var(--primary-clr)",
                    color: "var(--primary-clr)",
                  }}
                >
                  <h6
                    className="mb-0 fw-semibold"
                    style={{ color: "var(--primary-clr)", fontSize: "15px" }}
                  >
                    <i
                      className="fa fa-file-text me-2"
                      style={{ color: "var(--primary-clr)" }}
                    ></i>
                    Terms and Conditions <span className="text-danger">*</span>
                  </h6>
                </div>

                <div
                  className="card-body p-0 terms-editor-wrapper"
                  style={{ height: "300px", overflow: "hidden" }}
                >
                  <ReactQuill
                    theme="snow"
                    value={termsCondition}
                    onChange={(value) => {
                      setTermsCondition(value);
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    style={{ height: "280px" }}
                  />
                  {error.terms_err && (
                    <div className="error">{error.terms_err}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={data?._id ? handleUpdate : handleSubmit}
                        disabled={disable && !data?._id}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                          ? "Update"
                          : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ManagePurOrder;
